// extracted by mini-css-extract-plugin
module.exports = {"root":"ErrorsView_root__3iAnT","list":"ErrorsView_list__1jvGd"};